const DEFAULT_PADDING = 10;

const getAddressString = (
  address: string,
  city: string,
  state: string,
  country: string,
  zipCode: string,
  latLngOverride?: string
): string => {
  return latLngOverride
    ? latLngOverride
    : (address ? `${address}, ` : '') +
        (city ? `${city}, ` : '') +
        (state ? `${state}, ` : '') +
        (country ? `${country}, ` : '') +
        (zipCode ? zipCode : '');
};

const getStaticMapUrl = (addressString: string) => {
  return `https://exploretock.com/api/map?center=${encodeURIComponent(addressString)}`;
};

// I added this here mainly for preservation. I don't know if anyone will ever need it.
// The new <Map> requires a defaultZoom and defaultCenter or defaultBounds.
// Using both the defaultZoom and defaultCenter seem to be sufficient, which makes bounds unnecessary to me.
// There may be a need for this in Clowncar on the AreaForm maps.
const getBounds = (place: google.maps.places.PlaceResult, padding: number) => {
  const bounds = new google.maps.LatLngBounds();
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  bounds.extend(place.geometry!.location as google.maps.LatLng);
  // Don't zoom in too far on only one marker
  const buffer = 0.00004;
  if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
    const extendPoint1 = new google.maps.LatLng(
      bounds.getNorthEast().lat() + buffer,
      bounds.getNorthEast().lng() + buffer
    );
    const extendPoint2 = new google.maps.LatLng(
      bounds.getNorthEast().lat() - buffer,
      bounds.getNorthEast().lng() - buffer
    );

    bounds.extend(extendPoint1);
    bounds.extend(extendPoint2);
  }
  const mapDefaultBounds: google.maps.LatLngBoundsLiteral & {
    padding?: number | google.maps.Padding;
  } = {
    north: bounds.getNorthEast().lat() + buffer,
    south: bounds.getNorthEast().lng() + buffer,
    east: bounds.getNorthEast().lat() + buffer,
    west: bounds.getNorthEast().lng() + buffer,
    padding: padding ?? DEFAULT_PADDING,
  };
  return mapDefaultBounds;
};

export default {
  getAddressString,
  getStaticMapUrl,
  getBounds,
};
